import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AlertsState {
  showLoading: boolean;
  loadingMessage: string;

  showErrorDialog: boolean;
  errorMessage: string;

  showToast: boolean
  toastMessage: string

  showJobPublishAlert: boolean;
  showLoadingChat: boolean;
}

const initialState: AlertsState = {
  showLoading: false,
  loadingMessage: 'Loading ...',

  showErrorDialog: false,
  errorMessage: '',

  showToast: false,
  toastMessage: '',

  showLoadingChat: false,
  showJobPublishAlert: false,
};

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    showLoading(state, action: PayloadAction<boolean>) {
      state.showLoading = action.payload;
    },

    loadingMessage(state, action: PayloadAction<string>) {
      state.loadingMessage = action.payload;
    },

    showErrorMessage(state, action: PayloadAction<string>) {
      const message = action.payload;
      if (message != 'no_content'){
        state.errorMessage = message;
        state.showErrorDialog = !!(message && message.length > 0);
      }
    },

    showJobPublishAlert(state, action: PayloadAction<boolean>) {
      state.showJobPublishAlert = action.payload;
    },

    showLoadingChat(state, action: PayloadAction<boolean>) {
      state.showLoadingChat = action.payload;
    },

    showToastMessage(state, action: PayloadAction<string>) {
      const message = action.payload;
      state.showToast = !!message
      state.toastMessage = message
    }
  },
});

export const {
  showLoading,
  loadingMessage,
  showErrorMessage,
  showJobPublishAlert,
  showToastMessage,
  showLoadingChat
} = alertsSlice.actions;

export default alertsSlice.reducer;
